export default "__VITE_ASSET__KHQVEFT3__"